import { Injectable } from '@angular/core';
import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';
import { PluginListenerHandle } from '@capacitor/core';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KeyboardService {
  hide(): Observable<void> {
    return from(Keyboard.hide());
  }

  show(): Observable<void> {
    return from(Keyboard.show());
  }

  addListenerWillShow(callback: (info: KeyboardInfo) => void): Promise<PluginListenerHandle> {
    return Keyboard.addListener('keyboardWillShow', callback);
  }

  addListenerWillHide(callback: () => void): Promise<PluginListenerHandle> {
    return Keyboard.addListener('keyboardWillHide', callback);
  }

  addListenerDidShow(callback: (info: KeyboardInfo) => void): Promise<PluginListenerHandle> {
    return Keyboard.addListener('keyboardDidShow', callback);
  }

  addListenerDidHide(callback: () => void): Promise<PluginListenerHandle> {
    return Keyboard.addListener('keyboardDidHide', callback);
  }
}
